import React, {useLayoutEffect, useRef, useState} from 'react';
import {ThinkingText, ThinkingWrapper} from "./Thinking.styled";
import {Box, Link} from "@mui/material";
import {useTranslation} from "react-i18next";
import {tokens} from "../../../theme";

interface ThinkingProps {
    isGenerating: boolean;
    text: string;
}

const Thinking = ({isGenerating, text}: ThinkingProps) => {
    const {t} = useTranslation();

    const [isExpanded, setIsExpanded] = useState(false);
    const [isClamped, setIsClamped] = useState(false);

    const textRef = useRef<HTMLParagraphElement>(null);

    useLayoutEffect(() => {
        const textElement = textRef.current;
        if (textElement) {
            setIsClamped(textElement.scrollHeight > textElement.clientHeight);
        }
    }, [text]);

    return (
        <ThinkingWrapper $isGenerating={isGenerating}>
            <ThinkingText ref={textRef} $expanded={isExpanded}>
                {text}
            </ThinkingText>

            {(isClamped || isExpanded) && (
                <Box sx={{ textAlign: 'right' }}>
                    <Link
                        component="button"
                        onClick={() => setIsExpanded((e) => !e)}
                        sx={{ cursor: 'pointer', color: 'message.thinking', fontSize: tokens.fontSize.sm }}
                    >
                        {isExpanded ? t('chatMessages.showLess') : t('chatMessages.showMore')}
                    </Link>
                </Box>
            )}
        </ThinkingWrapper>
    );
};

export default Thinking;